class TrackedMap extends Map {
    constructor(init) {
        super();
        const { system, component, metric, metrics } = init;
        this.system = system ?? 'libp2p';
        this.component = component;
        this.metric = metric;
        this.metrics = metrics;
        this.updateComponentMetric();
    }
    set(key, value) {
        super.set(key, value);
        this.updateComponentMetric();
        return this;
    }
    delete(key) {
        const deleted = super.delete(key);
        this.updateComponentMetric();
        return deleted;
    }
    clear() {
        super.clear();
        this.updateComponentMetric();
    }
    updateComponentMetric() {
        this.metrics.updateComponentMetric({
            system: this.system,
            component: this.component,
            metric: this.metric,
            value: this.size
        });
    }
}
export function trackedMap(config) {
    const { system, component, metric, metrics } = config;
    let map;
    if (metrics != null) {
        map = new TrackedMap({ system, component, metric, metrics });
    }
    else {
        map = new Map();
    }
    return map;
}
